import styled from "styled-components";

export const HeaderContainer = styled.div`
  width: 100%;
  border-bottom: 2px solid #848484;
  margin-bottom: 16px;
  display: flex;
  padding-bottom: 8px;

  .solicitacaocaseNumber,
  .solicitacaoclassificacao {
    width: 12%;
  }
  .solicitacaoativo {
    width: 32%;
  }

  .solicitacaodataAbertura {
    width: 10%;
  }

  .solicitacaoagendamento {
    width: 14%;
  }

  .solicitacaostatus {
    width: 20%;
    position: relative;
    span {
      position: absolute;
      top: 3px;
      left: 45px;
    }
  }

  div {
    padding: 0 16px;
    span {
      color: #444444;
      font-weight: bold;
      font-size: 14px;
      .caseNumber {
        text-decoration: underline;
      }
    }
  }
`;
